export class ClarityService {
  setConsent(consent: boolean) {
    if (typeof window.clarity !== "function") {
      console.warn("[ClarityService.setConsent] Clarity is not available");
      return;
    }

    window.clarity('consentv2', {
      ad_Storage: "denied",
      analytics_Storage: consent ? "granted" : "denied"
    });
  }
}

export default new ClarityService();

declare global {
  interface Window {
      clarity?: (...args: any[]) => void;
  }
}
